module.exports = __webpack_public_path__ + "img/i1.d9b9064a.png";